<template>
  <div class="container">
    <!-- 顶部固定状态栏 -->
    <div class="head-top">
      <div class="text-1" @click="navigateTo('/about')">About Us</div>
      <div class="text-1" @click="navigateTo('/help')">Help & Support</div>
      <template v-if="authStore.userInfo">
        <div class="text-1" @click="navigateTo('/accountOrder')">
          Your Orders
        </div>
        <div class="text-1" @click="navigateTo('/member/accountDashboard')">
          Your Account
        </div>
        <div class="text-1">
          <a-dropdown :trigger="['click']">
            <a class="ant-dropdown-link">
              <img src="@/assets/image/use.png" alt="" class="use-icon" />
              {{
                authStore.userInfo.realname
                  ? "Hi," + authStore.userInfo.realname + "&nbsp; &nbsp;"
                  : "Hi, Guest&nbsp; &nbsp;"
              }}
              <DownOutlined />
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item key="0">
                  <a href="/member/yourGift">Your gifts & coupon</a>
                </a-menu-item>
                <!-- <a-menu-item key="1">
                  <a href="#">order</a>
                </a-menu-item> -->
                <a-menu-divider />
                <a-menu-item key="3" @click="signOut">sign out</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </template>
      <div v-else class="text-1" @click="signInHandler">
        <img src="@/assets/image/use.png" alt="" class="use-icon" />
        Sign In
      </div>
      <div class="text-1">
        <!-- <img src="@/assets/image/lunge.png" alt="" class="lunge-icon" /> -->
        <span class="el-dropdown-link">
          En<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
      </div>
    </div>
    <div class="head-2">
      <div class="head-2-top">
        <!-- 左侧抽屉 -->
        <img src="@/assets/image/newHome/nav.png" alt="" @click="showDrawer" class="titleNav" />
        <!-- logo区 -->
        <img src="@/assets/image/newHome/logo-20250416.png" alt="" width="2481" height="945" class="titleIcon" @click="navigateTo('/')" />
        <div class="head-2-top-right">
          <div class="bottom-cc">
            <div class="search">
              <!-- 搜索框 -->
              <div class="search-left">
                <img class="search-img" src="@/assets/image/newHome/serch.png" alt="" />
                <div class="search-input">
                  <input class="search-input-ip" placeholder="Search for product code / Brand / Type / Category"
                    v-model="searchstrs" @input="searchHandler" @blur="blurHandler" @focus="closeCategoryModal"
                    @keyup.enter="searchProds" />
                  <div v-if="searchstrs" class="close" @click="searchstrs = ''">
                    <CloseCircleOutlined />
                  </div>
                  <SearchLists v-show="searchFocused" customClass="search-dropdown" @select="handleSelectSearchItem"
                    :keywords="searchstrs" />
                </div>
              </div>
              <div class="search-btn" @click="searchProds">Search</div>
              <!-- 购物车图标 -->
              <div class="shop" @mouseenter="showShoppingHandler" @mouseleave="hideShoppingHandler">
                <!-- <img
                  src="@/assets/image/newHome/shop.png"
                  alt=""
                  class="shopping-img"
                  @click="(shopShow = false), navigateTo('/shoppingCart')"
                /> -->
                <a-badge :count="catStore.cartNumber" title="">
                  <img
                    src="@/assets/image/newHome/shop.png"
                    alt=""
                    class="shopping-img"
                    @click="closeShoppingHandler(), navigateTo('/shoppingCart')" />
                </a-badge>
                <div
                  v-if="token"
                  class="head-container-shop"
                  v-show="shopShow"
                  @mouseenter="cancelHideShopping"
                  @mouseleave="hideShoppingHandler">
                  <div class="shop-search">
                    <img src="@/assets/image/rightRed.png" alt="" class="shop-search-right" />
                    <div class="shop-search-input">
                      <div class="shop-search-input-btn" @click="clearAll">
                        Clear All
                      </div>
                      <div class="shop-search-input-btn" @click="closeShoppingHandler(), navigateTo('/shoppingCart')">
                        Go to Cart
                      </div>
                    </div>
                  </div>
                  <!-- <div class="shop-tips">
                      Replacement for Marco Number Descriptions Price Quantity Value
                  </div> -->
                  <div v-if="loading === true" class="white">
                    <Spin class="padding"></Spin>
                  </div>
                  <div v-else-if="shoppingCartList?.length === 0" class="shop-container">
                    <a-empty class="margin-top" />
                  </div>
                  <div v-else class="shop-container">
                    <div v-for="(item, index) in shoppingCartList" :key="index" class="shop-container-flex">
                      <div class="shop-container-item">
                        <div class="item-img">
                          <img @error="handleProductImageError" :src="item.mainImageUrl
                              ? getProductImageUrl(item.mainImageUrl, 200)
                              : defaultImage
                            " alt="" class="shop-img" />
                          <img src="@/assets/image/marco-logo.png" alt="" class="logo-img" />
                        </div>
                        <!-- <div class="text-item">{{ item.type }}</div> -->
                        <div class="text-item">{{ item.producer }}</div>
                        <div class="text-item2">
                          <!-- <div class="item2-text-1">{{ item.model }}</div> -->
                          <div class="item2-text-1">
                            {{ item.goodsSkuCode }}
                          </div>
                          <!-- <div class="item2-text-2">
                            {{ item.OE }}
                          </div> -->
                          <div class="item2-text-2">
                            {{ item.oeNumber }}
                          </div>
                        </div>
                        <!-- <div class="text-item3">
                          {{ item.parameters }}
                        </div> -->
                        <div class="text-item3">
                          {{ item.specName }}
                        </div>
                        <!-- <div class="text-item4">{{ item.unitPrice }}</div> -->
                        <div class="text-item4">{{ item.price }}</div>
                        <!-- <div class="text-item5">{{ item.number }}</div> -->
                        <div class="text-item5">{{ item.qty }}</div>
                        <!-- <div class="text-item5">{{ item.totalPrice }}</div> -->
                        <div class="text-item5">{{ item.amount }}</div>
                        <div class="text-item6" @click="deleteProd(item)">
                          <img src="@/assets/image/did1.png" alt="" class="did-img1" />
                          <img src="@/assets/image/did.png" alt="" class="did-img" />
                        </div>
                      </div>
                      <div class="line"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-text">Select by Vehicle</div>
            </div>
            <!-- 推荐型号 -->
            <div class="sub-text">
              Popular searches:
              <span class="mr-left"><span class="ltalic" v-for="(item, index) in searchKeywords"
                  :key="index"
                  @click="closeCategoryModal(), navigateTo(`/prod/all/${encodeURIComponent(item)}`)">
                  {{ item }}</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品分类 -->
    <!--begin-->
    <div v-if="catStore.categoryLoadError" class="category-load-error" role="alert">
      <span>{{ catStore.categoryLoadError }}</span>
      <button type="button" :disabled="catStore.isLoading" @click="loadCategories">Retry categories</button>
    </div>
    <div class="head-top-title">
      <NuxtLink
        v-for="item in catStore.formatedBackCategories"
        :key="item.id"
        :class="[
          'head-top-title-item',
          catStore.headTitle == item.id ? 'active2' : '',
        ]"
        :to="getTopCategoryPath(item)"
        @click.exact.prevent="switchCategoryHandler(item)"
      >
        {{ item.backCategoryName }}
      </NuxtLink>
      <div class="head-top-modal" v-if="catStore.showCategoryModal" @click.self="closeCategoryModal">
        <div class="container-1" @click.stop>
          <div>
            <div class="title">{{ catStore.title }}</div>
            <img src="@/assets/image/newHome/close.png" @click="closeCategoryModal" alt="" class="closeImg" />
          </div>
          <div class="head-top-modal-container">
            <NuxtLink
              v-for="item in catStore.currentSubCats"
              :key="item.id"
              class="head-top-modal-container-item"
              :to="getCategoryPath(item)"
              @click="closeCategoryModal"
            >
              <div class="item-top">
                <img
                  :key="item.icon || 'category-placeholder'"
                  :src="item.icon ? getImageUrl(item.icon) : defaultImage"
                  :alt="item.backCategoryName"
                  width="400"
                  height="400"
                  class="item-img"
                  :class="{ 'item-img--padded': hasVerifiedCatalogPadding(item.icon) }"
                  @error="handleImageError"
                />
              </div>
              <div class="item-bottom">{{ item.backCategoryName }}</div>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>

    <!--end-->

    <!-- 抽屉 -->
    <a-drawer v-model:open="open" class="custom-class" root-class-name="root-class-name" :root-style="{ color: 'blue' }"
      style="padding: 0" placement="left" :closable="false" width="30%">
      <div class="nav-drawer-container">
        <img src="@/assets/image/newHome/close.png" alt="" class="close-img" @click="open = false" />
        <img src="@/assets/image/newHome/black.png" alt="" @click="showBlack = false" class="black-img"
          v-if="showBlack" />
        <div v-if="!showBlack">
          <div class="nav-drawer-item">
            <div class="drawer-item-left">
              <img src="@/assets/image/newHome/nav-tel.png" alt="" />
            </div>
            <div class="drawer-item-content">0086-21-5785-2595</div>
            <div class="drawer-item-right">
              <img src="@/assets/image/newHome/right.png" alt="" />
            </div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left">
              <img src="@/assets/image/newHome/nav-kefu.png" alt="" />
            </div>
            <div class="drawer-item-content">Live Chat</div>
            <div class="drawer-item-right">
              <img src="@/assets/image/newHome/right.png" alt="" />
            </div>
          </div>
          <div class="nav-drawer-item" @click="drowHandler('/help')">
            <div class="drawer-item-left">
              <img src="@/assets/image/newHome/nav-help.png" alt="" />
            </div>
            <div class="drawer-item-content">Help Center</div>
            <div class="drawer-item-right">
              <img src="@/assets/image/newHome/right.png" alt="" />
            </div>
          </div>
          <div class="nav-drawer-item" @click="drowHandler('/member/accountDashboard')">
            <div class="drawer-item-left">
              <img src="@/assets/image/newHome/nav-user.png" alt="" />
            </div>
            <div class="drawer-item-content">Your Account</div>
            <div class="drawer-item-right">
              <img src="@/assets/image/newHome/right.png" alt="" />
            </div>
          </div>
          <div class="nav-drawer-item" @click="drowHandler('/collect')">
            <div class="drawer-item-left">
              <img src="@/assets/image/newHome/nav-like.png" alt="" />
            </div>
            <div class="drawer-item-content">Your Favorite</div>
            <div class="drawer-item-right">
              <img src="@/assets/image/newHome/right.png" alt="" />
            </div>
          </div>
          <div class="nav-drawer-item" @click="showBlack = true">
            <div class="drawer-item-left"></div>
            <div class="drawer-item-content">Applications</div>
            <div class="drawer-item-right">
              <img src="@/assets/image/newHome/right.png" alt="" />
            </div>
          </div>
          <div class="nav-drawer-title">Catalogue</div>

          <NuxtLink
            v-for="(item, index) in catStore.formatedBackCategories"
            :key="item.id"
            class="nav-drawer-item"
            :to="getTopCategoryPath(item)"
            @click.exact="closeNavigationDrawer"
          >
            <div class="drawer-item-left">
              <div class="img-wrap">
                <img :src="drawerPictureList[index].img" alt="" />
              </div>
            </div>
            <div class="drawer-item-content">
              {{ item.backCategoryName }}
            </div>
            <div class="drawer-item-right">
              <img src="@/assets/image/newHome/right.png" alt="" />
            </div>
          </NuxtLink>
        </div>
        <div v-if="showBlack" class="nav-drawer-wrap">
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/1.png" alt="" />
            </div>
            <div class="drawer-item-content">Automotive</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/2.png" alt="" />
            </div>
            <!-- <div class="drawer-item-content">Heavy duty</div> -->
            <div class="drawer-item-content">Trucks</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/3.png" alt="" />
            </div>
            <div class="drawer-item-content">Agriculture</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/4.png" alt="" />
            </div>
            <div class="drawer-item-content">Industrial & Construction</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/5.png" alt="" />
            </div>
            <div class="drawer-item-content">Forklift</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/6.png" alt="" />
            </div>
            <div class="drawer-item-content">Marine</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/7.png" alt="" />
            </div>
            <div class="drawer-item-content">Lawn & Gar</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/8.png" alt="" />
            </div>
            <div class="drawer-item-content">Hi-Performance</div>
          </div>
          <div class="nav-drawer-item">
            <div class="drawer-item-left detail-left">
              <img src="@/assets/image/newHome/9.png" alt="" />
            </div>
            <div class="drawer-item-content">EV</div>
          </div>
        </div>
      </div>
    </a-drawer>

    <!-- 固定位置快捷菜单 -->
    <div class="head-left">
      <!-- <div class="head-left-item" @click="navigateTo('/shoppingCart')">
        <img src="@/assets/image/head-left-item1.png" alt="" />
      </div> -->
      <a-badge :count="catStore.cartNumber" title="">
        <div class="head-left-item" @click="navigateTo('/shoppingCart')">
          <!-- <img src="@/assets/image/header/cart-default.png" alt="" /> -->
          <div class="cart"></div>
        </div>
      </a-badge>
      <div class="head-left-item" @click="navigateTo('/member/accountDashboard')">
        <!-- <img src="@/assets/image/header/user-default.png" alt="" /> -->
        <div class="user"></div>
      </div>
      <div class="head-left-item" @click="chatStore.changePageIndex(0)">
        <!-- <img src="@/assets/image/header/chat-default.png" alt="" /> -->
        <div class="chat"></div>
      </div>
      <!-- <a-badge :count="1" title="">
        <div class="head-left-item">
          <img src="@/assets/image/head-left-item3.png" alt="" />
        </div>
      </a-badge> -->
      <div class="chat-body">
        <component v-if="chatStore.pageIndex !== -1" :is="currentServiceComponent"></component>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getProductImageUrl, handleProductImageError } from '~/utils/productImageVariants';
import { computed, defineAsyncComponent, ref, onBeforeUnmount, onMounted } from "vue";
import { getSearchKeyword, searchRecord } from "@/api";
import { checkToken } from "@/api/login";
import { getShoppingCartList, delShoppingCart } from "@/api/shoppingCart";
import {
  buildHomeCategoryUrl,
  HOME_CATEGORY_QUERY_PARAM,
} from "@/composables/useProductLogicalNavigation";
import { useBackCategoryLoader } from "@/composables/useBackCategoryLoader";
import defaultImage from "@/assets/image/default.png";
import { hasVerifiedCatalogPadding } from "@/utils/catalogModalImage";
import SearchLists from "./SearchLists.vue";

import Starters from "@/assets/image/newHome/Starters.png";
import Alternators from "@/assets/image/newHome/Alternators.png";
import StarterParts from "@/assets/image/newHome/StarterParts.png";
import AlternatorParts from "@/assets/image/newHome/AlternatorParts.png";
import ACParts from "@/assets/image/newHome/ACParts.png";
import Motors from "@/assets/image/newHome/Motors.png";
import Electrical from "@/assets/image/newHome/Electrical.png";
import EV from "@/assets/image/newHome/EV.png";
import Spin from "./Spin.vue";

const chatStore = useChatStore();
const servicePageConfig = {
  0: defineAsyncComponent(() => import("../pages/service/index.vue")),
  1: defineAsyncComponent(() => import("../pages/service/contact.vue")),
  2: defineAsyncComponent(() => import("../pages/service/feedback.vue")),
  3: defineAsyncComponent(() => import("../pages/service/tickets.vue")),
  4: defineAsyncComponent(() => import("../pages/service/ticket.vue")),
  5: defineAsyncComponent(() => import("../pages/service/ticket/[id].vue")),
};

const currentServiceComponent = computed(() => servicePageConfig[chatStore.pageIndex] || servicePageConfig[0]);

const catStore = useCatStore();
const { loadCategories } = useBackCategoryLoader();

const authStore = useAuthStore();

const loading = ref();
const open = ref(false);
const shopShow = ref(false);
const shopShowAll = false;
let hideShoppingTimer = null;
// const showModal = ref(false);
const showBlack = ref(false);
// const title = ref("");
// const currentSubCats = ref([]);

const searchstrs = ref("");
const searchKeywords = ref([]);

const shoppingCartList = ref();

const searchFocused = ref(false);

const route = useRoute();

const closeCategoryModal = () => {
  if (catStore.showCategoryModal === false) {
    return;
  }
  catStore.changeShowCategoryModal(false);
  catStore.changeHeadTitle("");
};

// 展开收起分类逻辑
const switchCategoryHandler = (item) => {
  // 关闭状态点击展开并缓存展开数据
  if (catStore.showCategoryModal === false) {
    catStore.showCategoryHandler(item)
  } else {
    // 展开状态分类讨论
    if (catStore.headTitle === item.id) {
      catStore.changeShowCategoryModal(false);
      catStore.changeHeadTitle("");
    } else {
      catStore.showCategoryHandler(item)
    }
  }
}

// 展示购物车
const cancelHideShopping = () => {
  if (!hideShoppingTimer) return;
  clearTimeout(hideShoppingTimer);
  hideShoppingTimer = null;
};

const closeShoppingHandler = () => {
  cancelHideShopping();
  shopShow.value = false;
};

const hideShoppingHandler = () => {
  cancelHideShopping();
  hideShoppingTimer = setTimeout(() => {
    shopShow.value = false;
    hideShoppingTimer = null;
  }, 180);
};

const showShoppingHandler = () => {
  cancelHideShopping();
  if (catStore.cartNumber === 0) return;
  shopShow.value = true;
  // showModal.value = false;
  // 关闭分类弹窗
  catStore.changeShowCategoryModal(false);
  // 清楚分类id
  catStore.changeHeadTitle("");
};

const getCategoryPath = (item) =>
  getNavTemplateUrl(item.backParentId, item.id) + `${item.id}`;

const getTopCategoryPath = (item) => buildHomeCategoryUrl(item?.id);

const closeNavigationDrawer = () => {
  open.value = false;
  showBlack.value = false;
};

const openRequestedTopCategory = () => {
  if (!import.meta.client) return;

  const queryValue = route.query[HOME_CATEGORY_QUERY_PARAM];
  const requestedCategoryId = Array.isArray(queryValue) ? queryValue[0] : queryValue;
  if (!requestedCategoryId) return;

  const category = catStore.formatedBackCategories.find(
    (item) => String(item?.id) === String(requestedCategoryId),
  );
  if (
    !category ||
    (catStore.showCategoryModal && String(catStore.headTitle) === String(category.id))
  ) {
    return;
  }

  catStore.showCategoryHandler(category);
};

watch(
  [
    () => route.query[HOME_CATEGORY_QUERY_PARAM],
    () => catStore.formatedBackCategories,
  ],
  openRequestedTopCategory,
  { immediate: true },
);

// 图片错误处理
const handleImageError = (e) => {
  if (e.target.getAttribute('src') === defaultImage) return;
  // The placeholder has no verified white margins and must remain fully visible.
  e.target.dataset.catalogFallback = 'true';
  e.target.src = defaultImage;
};

// 页面跳转
const drowHandler = (path) => {
  navigateTo(path);
  open.value = false;
};

// 左侧抽屉图片
const drawerPictureList = ref([
  {
    id: 1,
    img: Starters,
  },
  {
    id: 2,
    img: Alternators,
  },
  {
    id: 3,
    img: StarterParts,
  },
  {
    id: 4,
    img: AlternatorParts,
  },
  {
    id: 5,
    img: ACParts,
  },
  {
    id: 6,
    img: Motors,
  },
  {
    id: 7,
    img: Electrical,
  },
  {
    id: 8,
    img: EV,
  },
]);

// 搜索框失焦事件
const blurHandler = () => {
  setTimeout(() => {
    searchFocused.value = false;
  }, 100);
};

// // 搜索框聚焦事件
// const focusHandler = () => {
//     searchFocused.value = true;
// }

// 处理选择搜索项事件
const handleSelectSearchItem = () => {
  // 这里可以处理选中项的逻辑，比如跳转到详情页等
  // console.log("选中的搜索项:", item);
  // navigateTo(`/prod/m/SBO340`);
  closeCategoryModal();
  searchFocused.value = false;
};

// 输入触发事件
const searchHandler = () => {
  closeCategoryModal();
  if (searchstrs.value.length < 2) {
    searchFocused.value = false;
    return;
  }
  searchFocused.value = true;
};

const searchProds = () => {
  closeCategoryModal();
  if (searchstrs.value) {
    searchRecord(searchstrs.value);
    navigateTo(`/prod/all/${encodeURIComponent(searchstrs.value)}`);
  }
};

// headTitle2: change sub-categories as mouse click
// watch(headTitle, (newValue, oldValue) => {
//   console.log(newValue);
//   let _backCategories = backCategories;
//   for (let i in _backCategories) {
//     if (_backCategories[i].id == newValue) {
//       let __cats = _backCategories[i].children;

//       __cats.sort((a, b) => a.sortNum - b.sortNum);
//       currentSubCats.value = __cats;
//       break;
//     }
//   }
// });

// 获取购物车列表
const getShoppingCarListHandler = async () => {
  loading.value = true;
  // console.log("enter getShoppingCarListHandler");
  // 重置购物车
  if (shoppingCartList.value.length) {
    shoppingCartList.value.length = 0;
  }

  await getShoppingCartList()
    .then((response) => {
      if (response.code === 200) {
        formatCartList(response);
        // shoppingCartList.value = response.result.marcoProdGoodsOverview;
        // number.value = shoppingCartList.value.qty;
      }
    })
    .catch((error) => {
      console.error(error);
      authStore.logoutHandler();
    })
    .finally(() => {
      const number = shoppingCartList.value.length;
      catStore.updateCartNumber(number || 0);
      loading.value = false;
    });
};

// 格式化购物车列表数据
const formatCartList = (result) => {
  result.result.forEach((item) => {
    let prodInfo = "marcoProdGoodsOverview";
    item[prodInfo].qty = item.qty;
    item[prodInfo].amount = item.amount;
    item[prodInfo].id = item.id;
    item[prodInfo].price = item.price;
    shoppingCartList.value.push(item.marcoProdGoodsOverview);
  });
};

//获取分类
const getSearchKeywordHandler = async () => {
  await getSearchKeyword()
    .then((res) => {
      if (res.code === 200) {
        searchKeywords.value = res.result;
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

// 展示抽屉
const showDrawer = () => {
  open.value = true;

  // showModal.value = false;
  catStore.changeShowCategoryModal(false);

  catStore.changeHeadTitle("");
};

// 验证登录状态
const checkTokenHandler = async () => {
  // }
  await checkToken()
    .then(() => {
      message.success("Succeeded in obtaining the login status. Procedure");
    })
    // 验证失败，删除token和用户信息，让用户重新登录获取token
    .catch(() => {
      message.error("Failed to obtain the login status. Procedure");
      authStore.logoutHandler();
    });
};

// 用于检测登录状态
const token = ref(localStorage.getItem("token") || "");

const signInHandler = () => {
  navigateTo("/login");
};

// 退出登录
const signOut = async () => {
  token.value = "";
  authStore.logoutHandler();
};

// 删除商品
const deleteProd = async (item) => {
  try {
    const res = await delShoppingCart({ body: item.id });
    if (res.code === 200) {
      message.success("successfully delete");
    } else {
      message.error("fail to delete");
    }
  } catch (error) {
    console.error(error);
    message.error("operation failure");
  }
  if (route.path.includes("shoppingCart")) {
    // 购物车页面刷新页面
    window.location.reload();
  } else {
    // 其他页面重新获取购物车数据
    getShoppingCarListHandler();
  }
};

// 清空购物车
const clearAll = async () => {
  let proIdStr = shoppingCartList.value.reduce(
    (result, current) => result + `,${current.id}`,
    ""
  );
  // console.log(proIdStr);

  await delShoppingCart({ body: proIdStr })
    .then((res) => {
      if (res.code === 200) {
        message.success("successfully delete");
      } else {
        message.error("fail to delete");
      }
    })
    .catch((error) => {
      console.error(error);
      message.error("operation failure");
    })
    .finally(() => {
      // 重新获取购物车数据
      getShoppingCarListHandler();
      // 更新页面
      window.location.reload();
    });
};

// todo : move to app.vue
//  Fetch search keywords on mount
onMounted(() => {
  // 清空购物车数据
  shoppingCartList.value = [];
  // 存在token即用户登录时
  // 获取首页购物车数据;
  if (token.value) {
    getShoppingCarListHandler();
  }
  // 验证登录状态
  // checkTokenHandler();
  // 获取首页分类数据
  getSearchKeywordHandler();
  // const number = localStorage.getItem("cartNumber");
  // catStore.updateCartNumber(number || 0);
});

onBeforeUnmount(() => {
  cancelHideShopping();
});

watch(
  // 监听购物车弹窗
  () => shopShow.value,
  (newValue) => {
    // 清空购物车数据
    shoppingCartList.value.length = 0;
    // 展开时，重新获取数据

    token.value = localStorage.getItem("token") || "";
    if (token.value && newValue === true) {
      getShoppingCarListHandler();
    }
  }
);
</script>
<style lang="less" scoped>
.category-load-error {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem;

  button {
    border: 1px solid #d41819;
    border-radius: 0.25rem;
    padding: 0.25rem 0.75rem;
    background: #fff;
    color: #d41819;
    cursor: pointer;
  }
}

.head-top-title {
  width: 1697px;
  margin: 0 auto;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;

  // z-index: 1;
  .head-top-title-item {
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    font-family: Galvji-Bold, Galvji-Bold;
    font-weight: normal;
    font-size: 19px;
    color: #231815;
    text-decoration: none;

    &:focus-visible {
      outline: 3px solid rgba(197, 30, 30, 0.28);
      outline-offset: 3px;
    }
  }

  .active2 {
    // width: 100%;
    border-bottom: 7px solid #c51e1e;
  }
}

.head-top-modal {
  position: absolute;
  top: 50px;
  left: -120px;
  width: 100vw;
  height: 200vh;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.3);

  .container-1 {
    border-top: 1px solid #231815;
    margin: 0 auto;
    width: 90%;
    background-color: #fff;
    position: relative;
    max-height: calc(100vh - 213px);
    overflow-y: auto;
    overscroll-behavior: contain;

    .title {
      font-size: 40px;
      margin: 50px 50px 0px 50px;
      font-weight: 500;
    }

    .closeImg {
      width: 22px;
      position: absolute;
      top: 20px;
      right: 24px;
      cursor: pointer;
    }
  }

  .head-top-modal-container {
    width: 1679px;
    margin: 0 auto;
    // height: 598px;
    background-color: #fff;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 0px 0px 50px 0px;

    // padding-left: 100px;
    .head-top-modal-container-item {
      // margin-right: 20px;
      cursor: pointer;
      color: inherit;
      margin-top: 20px;
      text-decoration: none;
      width: 20%;

      // width: 263px;
      // height: 195px;
      &:hover {
        text-decoration: underline;
      }

      &:focus-visible {
        outline: 3px solid rgba(197, 30, 30, 0.28);
        outline-offset: 4px;
      }

      .item-top {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 8.01vw;
        overflow: hidden;

        .item-img {
          flex-shrink: 0;
          width: 12.5vw;
          height: 8.01vw;
          max-width: 100%;
          object-fit: contain;
          display: block;

          // These immutable WebPs were audited pixel by pixel: cover removes
          // only their added white canvas, restoring the original label gap.
          &.item-img--padded:not([data-catalog-fallback]) {
            object-fit: cover;
          }
        }
      }

      .item-bottom {
        width: 100%;
        min-height: 40px;
        overflow-wrap: anywhere;
        white-space: normal;
        text-align: center;
        // font-family: Galvji-Bold, Galvji-Bold;
        font-weight: normal;
        font-size: 19px;
        color: #231815;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
      }
    }

    .head-top-modal-container-item:nth-child(6n) {
      margin-right: 0;
    }
  }
}

.head-top {
  width: 818px;
  height: 55px;
  background: #d41819;
  box-shadow: 4px 4 7px 0px rgba(35, 24, 21, 0.75);
  border-radius: 0px 0px 0px 30px;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  z-index: 5;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  font-family: Galvji, sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  .text-1 {
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 5px;
    border-radius: 10px;
    cursor: pointer;

    .el-dropdown-link {
      color: #fff;
      margin-left: 5px;
    }

    &:hover {
      background: #fff;
      color: #d41819;

      .el-dropdown-link {
        color: #d41819;
      }
    }

    .ant-dropdown-link {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .use-icon {
    width: auto;
    height: 23px;
  }

  .lunge-icon {
    width: auto;
    height: 23px;
  }
}

.head-2 {
  width: 100%;
  //    height:253px;
  background: url("@/assets/image/newHome/bd.png") no-repeat center center;
  background-size: 639px 234px;

  .head-2-top {
    // height:253px;
    display: flex;
    padding-top: 38px;
    height: 163px;
    box-sizing: border-box;
    //    align-items: center;
    padding-left: 118px;

    .titleNav {
      padding-top: 5px;
      width: 28px;
      height: 28px;
      margin-right: 25px;
      cursor: pointer;
    }

    .titleIcon {
      width: calc(75px * 2481 / 945);
      height: 75px;
      flex-shrink: 0;
      cursor: pointer;
    }

    .head-2-top-right {
      height: 166px;
      margin-left: 57px;
      display: flex;
      align-items: center;

      .top-cc {
        display: flex;

        // justify-content: space-around;
        .nav-item {
          // margin-right: 40px;
          margin-bottom: 28px;
          width: 125px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;

          &:hover {
            color: #d41819;

            img {
              transform: scale(1.2);
              /* 放大1.2倍 */
            }
          }

          img {
            width: 67px;
            height: 45px;
            margin-bottom: 5px;
            transition: transform 0.3s ease;
            /* 添加平滑过渡效果 */
          }

          font-family: Galvji,
          sans-serif;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
        }
      }

      .bottom-cc {
        .search {
          display: flex;
          align-items: center;
          height: 46px;

          .search-left {
            width: 1059px;
            height: 46px;
            background: #231815;
            border-radius: 10px 10px 10px 10px;
            padding-left: 17px;
            padding-right: 7px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .search-img {
              width: 27px;
              height: 27px;
            }

            .search-input {
              width: 990px;
              height: 35px;
              background: #ffffff;
              position: relative;

              .search-input-ip {
                width: 100%;
                height: 35px;
                box-sizing: border-box;
                padding-left: 9px;
                font-family: Galvji, sans-serif;
                font-weight: 400;
                font-size: 16px;
                display: block;
              }

              .close {
                font-size: 20px;
                position: absolute;
                top: 2px;
                right: 10px;
                cursor: pointer;

                &:hover {
                  color: #717071;
                  transition: color 0.1s ease-in-out;
                }
              }
            }
          }

          .search-btn {
            width: 103px;
            height: 46px;
            background: #231815;
            font-family: Galvji, sans-serif;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 2px;
            margin-right: 16px;
            border-radius: 10px;
            cursor: pointer;
          }

          .shop {
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;

            &::after {
              content: "";
              position: absolute;
              top: 50px;
              right: -220px;
              width: 1275px;
              height: 10px;
            }

            .shopping-img {
              width: 48px;
              height: 39px;
              cursor: pointer;
              // position: absolute;
            }

            .shop-search {
              display: flex;
              justify-content: flex-end;
              height: 62px;
              align-items: center;

              .shop-search-input {
                width: 305px;
                height: 35px;
                background: #717071;
                border-radius: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 20px;

                .shop-search-input-btn {
                  color: #fff;
                  font-family: Galvji, sans-serif;
                  font-weight: bold;
                  font-size: 22px;
                  cursor: pointer;

                  &:hover {
                    color: #d41819;
                  }
                }
              }

              img {
                width: 20px;
                margin-right: 5px;
              }
            }

            position: relative;
          }

          .right-text {
            font-family: Galvji-Oblique, Galvji-Oblique;
            font-weight: normal;
            font-size: 14px;
            color: #717071;
            margin-left: 45px;
            cursor: pointer;
            font-style: italic;
            text-decoration: underline;
          }

          margin-bottom: 12px;
        }

        .sub-text {
          font-family: Galvji, sans-serif;
          font-weight: 400;
          font-size: 16px;
          color: #231815;

          .mr-left {
            margin-left: 22px;
          }

          .ltalic {
            font-style: italic;
            margin-right: 10px;
            cursor: pointer;

            &:hover {
              color: #d41819;
            }
          }
        }
      }
    }
  }
}

.head-container-shop {
  background: #efefef;
  position: absolute;
  width: 1275px;
  height: 735px;
  // background: #EFEFEF;
  top: 60px;
  right: -220px;
  z-index: 3;
  // border-radius: 0 50px 0 0;
  padding: 0px 16px 16px;

  .shop-tips {
    font-family: Galvji, sans-serif;
    font-weight: bold;
    font-size: 22px;
    color: #ffffff;
    padding-left: 109px;
    margin-bottom: 16px;
  }

  .shop-container::-webkit-scrollbar {
    width: 10px;
    background-color: #f1f1f1;
  }

  /* 修改滚动条滑块的样式 */
  .shop-container::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 5px;
    /* 修改滑块圆角 */
  }

  /* 修改滚动条滑块悬停时的样式 */
  .shop-container::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  .shop-container {
    width: 1220px;
    height: 658px;
    background: #ffffff;
    border-radius: 0 50px 0 0;
    margin: 0 auto;
    overflow-y: scroll;

    /* 修改滚动条的宽度和颜色 */
    .shop-container-flex {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .line {
      width: 1198px;
      height: 1px;
      border-radius: 0px 0px 0px 0px;
      background-color: #dcdcdc;
    }

    .shop-container-item {
      width: 100%;
      height: 105px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .item-img {
        width: 150px !important;
        height: 86px !important;
        position: relative;
        overflow: hidden;

        .shop-img {
          // width: 150px;
          width: 120px;
          height: auto;
          transition: transform 0.3s ease;
          /* 添加平滑过渡效果 */
          margin-left: 30px;
        }

        .logo-img {
          position: absolute;
          width: 29px;
          left: 10px;
        }
      }

      .text-item {
        width: 100px;
        font-family: Galvji, sans-serif;
        font-weight: bold;
        font-size: 22px;
        color: #231815;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text-item2 {
        width: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .item2-text-1 {
          font-family: Galvji, sans-serif;
          font-weight: bold;
          font-size: 22px;
          color: #231815;
        }

        .item2-text-2 {
          font-family: Galvji, sans-serif;
          font-weight: bold;
          font-size: 15px;
          color: #231815;
        }
      }

      .text-item3 {
        width: 140px;
        font-family: Galvji, sans-serif;
        font-weight: bold;
        font-size: 15px;
        color: #231815;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text-item4 {
        width: 70px;
        font-family: Galvji, sans-serif;
        font-weight: bold;
        font-size: 15px;
        color: #231815;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text-item5 {
        width: 70px;
        font-family: Galvji, sans-serif;
        font-weight: bold;
        font-size: 22px;
        color: #231815;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text-item6 {
        padding-right: 14px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .did-img {
        width: 20px !important;
        height: 20px !important;
        display: none;
      }

      .did-img1 {
        width: 20px !important;
        height: 20px !important;
      }

      &:hover {
        .item-img {
          .shop-img {
            transform: scale(1.2);
            /* 放大1.2倍 */
          }
        }

        .text-item2 {
          .item2-text-1 {
            color: #d71718;
          }
        }

        .text-item6 {
          .did-img1 {
            display: none;
          }

          .did-img {
            display: block;
          }
        }
      }
    }
  }
}

.nav-drawer-container {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 35px;
  box-sizing: border-box;

  .close-img {
    position: absolute;
    width: 22px;
    height: 22px;
    cursor: pointer;
    right: 25px;
    top: 12px;
  }

  .black-img {
    position: absolute;
    width: 22px;
    height: 22px;
    cursor: pointer;
    left: 25px;
    top: 12px;
  }

  .nav-drawer-title {
    font-family: Galvji-Bold, Galvji-Bold;
    font-weight: normal;
    font-size: 27px;
    color: #231815;
    padding-left: 51px;
    margin-top: 35px;
    margin-bottom: 20px;
  }

  .nav-drawer-item {
    box-sizing: border-box;
    color: inherit;
    height: 52px;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 50px;
    padding-right: 48px;
    cursor: pointer;
    text-decoration: none;

    &:focus-visible {
      outline: 3px solid rgba(197, 30, 30, 0.28);
      outline-offset: -3px;
    }

    .drawer-item-left {
      width: 42px;
      // height: 42px;
      margin-right: 27px;

      .img-wrap {
        width: 150%;
      }

      img {
        width: 100%;
        height: auto;
      }
    }

    .detail-left {
      width: 89px;
      display: flex;
      align-items: center;

      img {
        width: 100%;
        height: auto;
      }
    }

    .drawer-item-content {
      width: 375px;
      font-family: Galvji, Galvji;
      font-weight: normal;
      font-size: 18px;
      color: #231815;
    }

    .drawer-item-right {
      img {
        width: 13px;
        height: 16px;
      }
    }

    &:hover {
      background-color: #eeeeef;

      .drawer-item-content {
        font-family: Galvji-Bold, Galvji-Bold;
        font-weight: normal;
        font-size: 18px;
        color: #231815;
        // font-weight: 800;
      }
    }
  }

  .nav-drawer-wrap {
    display: flex;
    flex-direction: column;

    .nav-drawer-item {
      box-sizing: border-box;
      height: 52px;
      width: 100%;
      display: flex;
      align-items: center;
      padding-left: 50px;
      padding-right: 48px;
      cursor: pointer;
      margin-top: 20px;

      .drawer-item-left {
        width: 42px;
        height: 42px;
        margin-right: 27px;

        img {
          width: 100%;
          height: auto;
        }
      }

      .detail-left {
        width: 89px;
        display: flex;
        align-items: center;

        img {
          width: 100%;
          height: auto;
        }
      }

      .drawer-item-content {
        width: 375px;
        font-family: Galvji, Galvji;
        font-weight: normal;
        font-size: 18px;
        color: #231815;
      }

      .drawer-item-right {
        img {
          width: 13px;
          height: 16px;
        }
      }

      &:hover {
        background-color: #eeeeef;

        .drawer-item-content {
          font-family: Galvji-Bold, Galvji-Bold;
          font-weight: normal;
          font-size: 18px;
          color: #231815;
          // font-weight: 800;
        }
      }
    }
  }
}

.head-left {
  position: fixed;
  right: 10px;
  top: 591px;
  // width: 71px;
  // height: 200px;
  width: 3.5vw;
  height: 7.4vw;
  // padding: 10px 0;
  padding-bottom: 0.10vw;
  background: #231815;
  border-radius: 10px;
  z-index: 9;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  .head-left-item {
    // width: 48px;
    // height: 40px;
    width: 2.5vw;
    height: 2.08vw;
    cursor: pointer;
    position: relative;

    .cart {
      width: 2.5vw;
      /* 设置图片尺寸 */
      height: 2.5vw;
      // width: 100%;
      // height: 100%;
      background-image: url("@/assets/image/header/cart-default.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      transition: background-image 0.3s ease;
      cursor: pointer;

      &:hover {
        background-image: url("@/assets/image/header/cart-active.png");
      }
    }

    .user {
      width: 100%;
      height: 100%;
      background-image: url("@/assets/image/header/user-default.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      transition: background-image 0.3s ease;
      cursor: pointer;

      &:hover {
        background-image: url("@/assets/image/header/user-active.png");
      }
    }

    .chat {
      width: 100%;
      height: 100%;
      background-image: url("@/assets/image/header/chat-default.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      transition: background-image 0.3s ease;
      cursor: pointer;

      &:hover {
        background-image: url("@/assets/image/header/chat-active.png");
      }
    }
  }

  .service {
    position: fixed;
    right: 5vw;
    top: 450px;
    padding: 10px 0;
    background: #231815;
    border-radius: 10px;
    z-index: 9;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 32vw;
    height: 30vw;
    border: black solid 1px;
    background-color: #fff;

    .header {
      .logo {
        padding: 40px;
        display: flex;
        justify-content: center;

        .logo-img {
          width: auto;
          height: 75px;
          cursor: pointer;
        }
      }

      .title {
        font-size: 32px;
        font-weight: 600;
      }
    }

    .body {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .item {
        height: 20%;
        width: 75%;
        border: black solid 1px;
        margin-bottom: 1.5vw;

        .contact {
          display: flex;
          justify-content: center;
          align-items: center;
          width: max-content;

          .icon {
            padding: 1vw;
            padding-top: 0vw;
            font-size: 1.8vw;
          }

          .text {
            .item-title {
              font-weight: 500;
            }

            .item-subTitle {}
          }
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.ant-drawer-body {
  padding: 0 !important;
}

.ant-drawer-body::-webkit-scrollbar {
  width: 10px;
  background-color: #f1f1f1;
}

/* 修改滚动条滑块的样式 */
.ant-drawer-body::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 5px;
  /* 修改滑块圆角 */
}

/* 修改滚动条滑块悬停时的样式 */
.ant-drawer-body::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

// 购物车空状态边距
.margin-top {
  margin-top: 20%;
}

.white {
  background: #fff;
}

.padding {
  padding: 20% 0;
}

// 侧边栏固定购物车数字
.head-left {
  :deep(.ant-badge-count) {
    // transform: translate(0%, 30%);
    transform: translate(0%, 0%);
  }
}
</style>
